<template>
	<table :class="[ 'table', striped && 'table-striped' , bordered && 'table-bordered',hover&&'table-hover',condensed&&'table-condensed'  ]">
		<thead v-if="columnProps.length > 0">
			<tr>
				<td v-for="(item,idx) in columnProps">
					{{ item.label }}
				</td>
			</tr>
		</thead>
		<tbody v-if="columnProps.length > 0">
			<tr v-for="data in data">
				<td v-for="(item,idx) in columnProps">{{ item | inline(data) }}</td>
			</tr>
		</tbody>
	</table>
</template>

<script>
	export default {
		props: {
			bordered: Boolean,
			striped: Boolean,
			hover: Boolean,
			condensed: Boolean,
			data: {
				type: Array,
				default() {
					return []
				}
			}
		},
		computed: {
			columnProps() {
				let nodes = this.$slots.default
				let labels = []
				let len = nodes.length
				nodes && nodes.forEach(item => {
					item.tag && labels.push(Object.assign(item.componentOptions && item.componentOptions.propsData || {}, item.data && item.data.attrs || {}))
				})
//				console.log(nodes)
//				console.log(labels)
				return labels
			}
		},
		filters: {
			inline(props, data) {
				return data[props.prop]
			}
		},
		mounted() {

		}
	}
</script>
<style lang="less">
	@import (reference) "../../assets/lib/css.less";
	table {
		thead {
			td {
				.blod;
				background-color: @bgc;
			}
		}
		&.table-bordered {
			thead {
				td {
					border-bottom-width: 1px;
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// table.vue?24f3bf56